import { ajaxJson } from 'imports/ajax';
import { createTypes } from 'redux-create-types';


const namespace = 'navbar';

export const navbarActions = createTypes([
    'getUserInfoFromApi',
    'setUnSeenMessages',
    'setError',
    'setNotifList',
    'setNotifsCount',
    'toggleNotifsList',
    'hideNotifsList'
], namespace);


function toggleNotifsList(payload) {
    return dispatch => {
        dispatch({
            type: navbarActions.toggleNotifsList,
            payload: payload,
        })
    }
}

function hideNotifsList(){
    return dispatch => {
        dispatch({
            type: navbarActions.hideNotifsList
        })
    }
}

function setNotifsCount(notifsCount) {
    return dispatch => {
        dispatch({
            type: navbarActions.setNotifsCount,
            payload: notifsCount,
        })
    }
}

function setNotifList(notifs) {
    return dispatch => {
        dispatch({
            type: navbarActions.setNotifList,
            payload: notifs
        })
    }
}


function getNotificationsApiSuccess(res) {
    return dispatch => {
        dispatch(setNotifList(res.data.notifications));
        dispatch(setNotifsCount(res.data.unseen_messages));
    }
}

function getNotificationsFromApi() {
    return (dispatch, getState) => {
        return ajaxJson.get('/users/new_site_notifications')
            .then(
                res => dispatch(getNotificationsApiSuccess(res)),
                err => dispatch(getNotificationsApiFail(err))
            )
    }
}


function getNotificationsApiFail(err) {
    return dispatch => {
        dispatch({
            type: navbarActions.setError,
            payload: err,
        })
    }
}

function setUnSeenMessages(unSeenMessages) {
    return dispatch => {
        dispatch({
            type: navbarActions.setUnSeenMessages,
            payload: unSeenMessages,
        })
    }
}

function getUserInfoApiFail(err) {
    return dispatch => {
        dispatch({
            type: navbarActions.setError,
            payload: err,
        })
    }
}

function getUserInfoApiSuccess(res) {
    return dispatch => {
        dispatch(setUnSeenMessages(res.data.unseen_messages))
    }
}

function getUserInfoFromApi() {
    return dispatch => {
        return ajaxJson.get('/users/info')
            .then(
                res => dispatch(getUserInfoApiSuccess(res)),
                err => dispatch(getUserInfoApiFail(err))
            )
    }
}


export const navbarActionCreators = {
    getUserInfoFromApi,
    getNotificationsFromApi,
    toggleNotifsList,
    hideNotifsList
} 
